import {
  faEye,
  faEyeSlash,
} from '@awesome.me/kit-f3dc60f0d0/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from '@lingui/react/macro';
import {
  Button,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@repo/videa-components/src/index';
import { isToday } from 'date-fns';
import { useAtomValue } from 'jotai';
import { useSelector } from 'react-redux';

import { DiveBar } from '../../app/snackbar/Divebar';
import { useUpdateAssistSettings } from '../../react-query/useUpdateAssistSettings';
import { mixpanelEvents, useTrackEvent } from '../../utils/mixpanel';

import { selectDateAtom } from './atoms';
import * as Styled from './styles';

interface Props {
  source?:
    | 'PATIENT_LIST'
    | 'HUDDLE_PRINTOUT'
    | 'CLAIMS'
    | 'AUTOVERIFY'
    | 'REFERRALS'
    | 'IMAGE_VIEWER';
  className?: string;
}

export const PrivacyButton = ({ source, className }: Props) => {
  const { mutate, isError, isLoading, reset } = useUpdateAssistSettings();
  const displayPhi = useSelector((state: any) => state.login?.user?.privacyOn);
  const { trackEvent } = useTrackEvent();
  const selectedDate = useAtomValue(selectDateAtom);

  const handleTogglePrivacy = () => {
    const isNewDisplayPhi = !displayPhi;
    mutate({ privacyOn: isNewDisplayPhi });
    trackEvent(mixpanelEvents.privacyToggle, {
      // if we're displaying PHI, from the product standpoint, privacy is enabled - flip these.
      // if the database value is true, then we're displaying PHI despite the var name, 'privacyOn'
      // insinuating otherwise.
      privacyEnabled: !isNewDisplayPhi,
      source,
      date: selectedDate,
      isToday: selectedDate ? isToday(selectedDate) : false,
    });
  };

  return (
    <Styled.PrivacyButtonContainer>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            className={`vai-w-9 vai-h-9 ${className || ''} ${
              displayPhi ? 'displayed' : ''
            }`}
            size="icon"
            variant="ghostIcon"
            onClick={handleTogglePrivacy}
            disabled={isLoading}
            data-testid="privacy-button"
          >
            <FontAwesomeIcon icon={displayPhi ? faEye : faEyeSlash} />
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>
            <Trans>Toggle privacy</Trans>
          </p>
        </TooltipContent>
      </Tooltip>

      <br />

      <DiveBar
        open={isError}
        message="Error saving privacy settings, please contact videa for support"
        severity="error"
        closable={true}
        handleClose={reset}
      />
    </Styled.PrivacyButtonContainer>
  );
};
